import { render, staticRenderFns } from "./BooleanLabel.vue?vue&type=template&id=5d05f308"
import script from "./BooleanLabel.vue?vue&type=script&lang=js"
export * from "./BooleanLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports